import styled from 'styled-components';

export const StyledDiv = styled.div`
  margin: 0.5em 0;
`;
